/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Play_Store_Badge_AltInputs */

const en_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play store badge`)
};

const id_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lencana Play Store`)
};

const ms_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lencana Play store`)
};

const ca_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insígnia de la Play store`)
};

const cs_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odznak obchodu Play store`)
};

const da_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play store-badge`)
};

const de_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store-Abzeichen`)
};

const et_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store'i märk`)
};

const es_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insignia de Play Store`)
};

const fr_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge Play Store`)
};

const hr_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznaka Play store`)
};

const it_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badge Play Store`)
};

const lv_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store emblēma`)
};

const lt_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Play store“ ženklelis`)
};

const hu_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play áruház jelvény`)
};

const nl_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store-badge`)
};

const nb_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store-merke`)
};

const pl_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znaczek Play Store`)
};

const pt_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ícone da Play Store`)
};

const ro_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insigna magazin Play`)
};

const sk_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odznak Play store`)
};

const sl_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Značka Play store`)
};

const fi_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play-kaupan merkki`)
};

const sv_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store-märke`)
};

const vi_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biểu tượng cửa hàng Play`)
};

const tr_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store rozeti`)
};

const el_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σήμα Play store`)
};

const bg_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значка на Play Store`)
};

const ru_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значок Play store`)
};

const sr_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Store значка`)
};

const uk_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значок Play Store`)
};

const ka_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play store-ს ბეიჯი`)
};

const hi_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्ले स्टोर बैज`)
};

const th_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้ายแสดงสถานะใน Play Store`)
};

const ko_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play 스토어 배지`)
};

const zh_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play store 徽章`)
};

const zh_tw_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play 商店徽章`)
};

const ja_play_store_badge_alt = /** @type {(inputs: Play_Store_Badge_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playストアバッジ`)
};

/**
* | output |
* | --- |
* | "Play store badge" |
*
* @param {Play_Store_Badge_AltInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const play_store_badge_alt = /** @type {((inputs?: Play_Store_Badge_AltInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Play_Store_Badge_AltInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_play_store_badge_alt(inputs)
	if (locale === "ms") return ms_play_store_badge_alt(inputs)
	if (locale === "ca") return ca_play_store_badge_alt(inputs)
	if (locale === "cs") return cs_play_store_badge_alt(inputs)
	if (locale === "da") return da_play_store_badge_alt(inputs)
	if (locale === "de") return de_play_store_badge_alt(inputs)
	if (locale === "et") return et_play_store_badge_alt(inputs)
	if (locale === "es") return es_play_store_badge_alt(inputs)
	if (locale === "fr") return fr_play_store_badge_alt(inputs)
	if (locale === "hr") return hr_play_store_badge_alt(inputs)
	if (locale === "it") return it_play_store_badge_alt(inputs)
	if (locale === "lv") return lv_play_store_badge_alt(inputs)
	if (locale === "lt") return lt_play_store_badge_alt(inputs)
	if (locale === "hu") return hu_play_store_badge_alt(inputs)
	if (locale === "nl") return nl_play_store_badge_alt(inputs)
	if (locale === "nb") return nb_play_store_badge_alt(inputs)
	if (locale === "pl") return pl_play_store_badge_alt(inputs)
	if (locale === "pt") return pt_play_store_badge_alt(inputs)
	if (locale === "ro") return ro_play_store_badge_alt(inputs)
	if (locale === "sk") return sk_play_store_badge_alt(inputs)
	if (locale === "sl") return sl_play_store_badge_alt(inputs)
	if (locale === "fi") return fi_play_store_badge_alt(inputs)
	if (locale === "sv") return sv_play_store_badge_alt(inputs)
	if (locale === "vi") return vi_play_store_badge_alt(inputs)
	if (locale === "tr") return tr_play_store_badge_alt(inputs)
	if (locale === "el") return el_play_store_badge_alt(inputs)
	if (locale === "bg") return bg_play_store_badge_alt(inputs)
	if (locale === "ru") return ru_play_store_badge_alt(inputs)
	if (locale === "sr") return sr_play_store_badge_alt(inputs)
	if (locale === "uk") return uk_play_store_badge_alt(inputs)
	if (locale === "ka") return ka_play_store_badge_alt(inputs)
	if (locale === "hi") return hi_play_store_badge_alt(inputs)
	if (locale === "th") return th_play_store_badge_alt(inputs)
	if (locale === "ko") return ko_play_store_badge_alt(inputs)
	if (locale === "zh") return zh_play_store_badge_alt(inputs)
	if (locale === "zh-tw") return zh_tw_play_store_badge_alt(inputs)
	if (locale === "ja") return ja_play_store_badge_alt(inputs)
	return en_play_store_badge_alt(inputs)
});